<template>
  <section-vue class="business-app-screen">
    <div class="business-app-screen__container container">
      <div class="business-app-screen__body grid-css">
        <pict
          block-name="business-app-screen"
          :default="{
            src: $options.image[$i18n.locale]['1x'],
            srcset: {
              '2x': $options.image[$i18n.locale]['2x']
            }
          }"
        />

        <div class="business-app-screen__copy">
          <h2 class="business-app-screen__headline">
            {{ $t("headline") }}
          </h2>

          <ul
            class="business-app-screen__highlights"
            v-html="
              $t('highlights', {
                totalBooks: $options.totalBooks,
                totalCategories: $options.totalCategories
              })
            "
          />
        </div>
      </div>
    </div>
  </section-vue>
</template>

<script>
import SectionVue from "@/shared/section"
import imageEn from "@/pages/business/images/phone-mockup/phone-mockup-en.png"
import imageEn2x from "@/pages/business/images/phone-mockup/phone-mockup-en@2x.png"
import imageDe from "@/pages/business/images/phone-mockup/phone-mockup-de.png"
import imageDe2x from "@/pages/business/images/phone-mockup/phone-mockup-de@2x.png"
import Pict from "@/shared/pict"
import globals from "@/utils/globals"

export default {
  name: "BusinessAppScreen",
  components: {
    SectionVue,
    Pict
  },
  totalBooks: globals.totalBooks,
  totalCategories: globals.totalCategories,
  image: {
    en: {
      "1x": imageEn,
      "2x": imageEn2x
    },
    de: {
      "1x": imageDe,
      "2x": imageDe2x
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "Build your team’s learning habit with these features",
        highlights: `
          <li>Award-winning, <strong>mobile-first microlearning</strong>—let your team take control of how, when, and where they learn.</li>
          <li>Key ideas from <strong>{totalBooks}+ bestselling nonfiction books and podcasts</strong> that your team can read or listen to in 15-mins.</li>
          <li>{totalCategories} categories for <strong>personal and professional growth</strong>—give your team the knowledge to develop in every facet of life, not just work.</li>
          <li>Curated collections and <strong>personalized recommendations</strong> to keep your team engaged.</li>
          <li><strong>40 new titles</strong> added each month, plus learning reminders so your curious minds stay satisfied.</li>
         `
      },
      de: {
        headline: "Ihre Vorteile mit Blinkist Business",
        highlights: `
          <li>Die <strong>preisgekrönte App</strong> vereint Premium-Inhalte mit Praktikabilität für die individuellen Bedürfnisse Ihrer Mitarbeiter.</li>
          <li><strong>Analysetools</strong> geben Aufschluss über die Lern- und Weiterbildungs-Ansprüche Ihres Teams.</li>
          <li>Sie bilden sich weiter mit mehr als <strong>2.000 Titeln aus dem Business-Kontext</strong>, zahlreichen Bestsellern und Klassikern.</li>
          <li>Ein <strong>intelligenter Algorithmus</strong> sowie ein Team aus Redakteuren sorgen für <strong>individuelle und relevante Empfehlungen.</strong></li>
          <li>Das Blinkist-Angebot wächst ständig: <strong>Jeden Monat</strong> kommen <strong>40 neue Titel</strong> hinzu.</li>
         `
      }
    }
  }
}
</script>

<style lang="scss">
.business-app-screen {
  background-color: $pale-mint-grey;

  &__body {
    @include grid-css;

    align-items: center;
  }

  &__picture {
    @include grid-css-element(12);

    position: relative;

    display: flex;
    justify-content: center;
    order: 2;
    padding-top: 154%;

    @include media(min-width, m) {
      @include grid-css-element(5);

      order: 1;
    }
  }

  &__image {
    position: absolute;
    top: 0;

    display: block;
    width: 100%;
    max-width: 24rem;
  }

  &__copy {
    @include grid-css-element(12);

    display: flex;
    flex-direction: column;
    justify-content: center;
    order: 1;
    margin-bottom: $spacing-32;

    @include media(min-width, m) {
      @include grid-css-element(7, 6);

      order: 2;
      margin-bottom: 0;
    }

    @include media(min-width, l) {
      @include grid-css-element(6, 7);

      order: 2;
    }
  }

  &__headline {
    margin-bottom: $spacing-48;
  }

  &__highlights {
    @include p0;

    padding-left: $spacing-32;

    list-style-type: disc;

    li:not(:last-child) {
      margin-bottom: $spacing-24;
    }
  }
}
</style>
